/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1JpmamJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_JPMAM_JOB_EVENT_ENTITY_NAME = 'exc.jpmam.v1.JpmamJobEvent';
export const excJpmamV1JpmamJobEventEntity = new schema.Entity<ExcJpmamV1JpmamJobEvent>(EXC_JPMAM_V1_JPMAM_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcJpmamV1JpmamJobEvent) => `${entity.metadata?.eventId}` });

